export const initTables = () => {
	const tables = document.querySelectorAll( 'section.table' );

	if ( !tables )
	{
		return;
	}

	Array.from( tables ).forEach( ( it ) => {
		let tableWidth = it.querySelector( 'table' ).getBoundingClientRect().width;
		let commonWidth = 0;
		let currentPosition = 0;
		let currentPositionTop = 0;

		it.querySelector( 'ul.buttons li.back' ).classList.add( 'disabled' );
		
		it.querySelector( 'div.table-wrapper' ).dataset.columns = it.querySelector( 'tr' ).querySelectorAll( 'td' ).length > 5 ? 5 : it.querySelector( 'tr' ).querySelectorAll( 'td' ).length;

		Array.from( it.querySelector( 'tr:nth-child( 2 )' ).querySelectorAll( 'td' ) ).forEach( ( cell ) => {
			commonWidth += cell.getBoundingClientRect().width;
		} );

		it.querySelector( 'ul.buttons' ).addEventListener( 'click', ( evt ) => {
			const direction = evt.target.classList.contains( 'back' ) ? 1 : -1;
			const step = it.querySelector( 'tr:nth-child( 2 ) td:nth-child( 2 )' ).getBoundingClientRect().width;

			currentPosition += direction * step;
			currentPositionTop += window.innerWidth * direction;

			Array.from( it.querySelectorAll( 'td:not( :first-child )' ) ).forEach( ( cell ) => {
				cell.style.transform = `translateX( ${window.innerWidth < 1024 && cell.closest( 'tr:first-child' ) ? currentPositionTop : currentPosition}px )`;
			} );

			if ( currentPosition < 0 )
			{
				it.querySelector( 'ul.buttons li.back' ).classList.remove( 'disabled' );
			}
			else
			{
				it.querySelector( 'ul.buttons li.back' ).classList.add( 'disabled' );
			}

			if ( currentPosition > tableWidth - 2 - commonWidth )
			{
				it.querySelector( 'ul.buttons li.forward' ).classList.remove( 'disabled' );
			}
			else
			{
				it.querySelector( 'ul.buttons li.forward' ).classList.add( 'disabled' );
			}
		} );

		window.addEventListener( 'resize', () => {
			tableWidth = it.querySelector( 'table' ).getBoundingClientRect().width;
			commonWidth = 0;
			currentPosition = 0;
			currentPositionTop = 0;

			Array.from( it.querySelector( 'tr:nth-child( 2 )' ).querySelectorAll( 'td' ) ).forEach( ( cell ) => {
				commonWidth += cell.getBoundingClientRect().width;
			} );

			Array.from( it.querySelectorAll( 'td:not( :first-child )' ) ).forEach( ( cell ) => {
				cell.style.transform = 'translateX( 0 )';
			} );

			it.querySelector( 'ul.buttons li.back' ).classList.add( 'disabled' );
			it.querySelector( 'ul.buttons li.forward' ).classList.remove( 'disabled' );
		} );
	} );
};
